import { HugeiconsIcon } from "@hugeicons/react";
import { PlusSignIcon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import {
  CompanySearchFilter,
  CompanyTable,
  CompanyDrawer,
  useCompanyList,
  useCompanyStore,
} from "@/features/company";

export default function CompaniesPage() {
  const searchParams = useCompanyStore((s) => s.searchParams);
  const openDrawerForAdd = useCompanyStore((s) => s.openDrawerForAdd);
  const { data, isLoading } = useCompanyList(searchParams);

  return (
    <div className="flex h-full flex-col p-4 bg-slate-50/50">
      {/* Page Header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900">배차 업체 관리</h1>
          <p className="mt-0.5 text-xs text-gray-600">
            등록된 배차 업체를 관리합니다
          </p>
        </div>
        <Button
          size="sm"
          onClick={openDrawerForAdd}
          className="bg-blue-600 px-3 py-1.5 text-sm font-bold hover:bg-blue-700"
        >
          <HugeiconsIcon icon={PlusSignIcon} size={14} className="mr-1.5" />
          신규 등록
        </Button>
      </div>

      {/* Search/Filter Bar */}
      <div className="mb-4 rounded-lg border border-gray-200">
        <CompanySearchFilter />
      </div>

      {/* Data Table */}
      <CompanyTable data={data} isLoading={isLoading} />

      {/* Drawer */}
      <CompanyDrawer />
    </div>
  );
}
